import client from './client'
import install from './install'

// 子模块
import api from './api'
import apiAsync from './apiAsync'

import author from './author'

export default class AdminApi {
  constructor (options) {
    if (AdminApi.instance) {
      throw new Error('AdminApi is singleton')
    }
    AdminApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.author = author

    this.api = api
    this.apiAsync = apiAsync
  }
  static getInstance () {
    return AdminApi.instance
  }
}

AdminApi.instance = null
AdminApi.install = install



// WEBPACK FOOTER //
// ./src/apis/admin-api/index.js